const env = {
    development: 'http://localhost:8000',
    // development: 'https://api-beta.makrodlahandlu.pl',
    beta: 'https://api-beta.foodlovers.makro.pl',
    production: 'https://api.foodlovers.makro.pl',
}

export default {
    googleGeocodeUrl: "https://maps.googleapis.com",
    googleGeocodePath: "/maps/api/geocode/json",
    googleApiKey: "AIzaSyDm3k3larmYy1gD0RbKdGxKL-g8Y3RhEWA",
    makroApiUrl: env[process.env.VUE_APP_BUILD_ENV] || env.development,
    WITH_CREDENTIALS: false,
    LOG_REQUESTS: true
}

